/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SignIn/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Credentials from './Credentials/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import TwoFactorAuth from './TwoFactorAuth/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2BrandLogo from 'DesignSystem/Svgs/Tysiav2BrandLogo/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function SignIn({
  children,
  viewPath = "/App/Auth/SignIn"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Credentials'
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="SignIn.Vertical"
  data-view-path={viewPath}
 style={{'--bc-3-Z29l7Yn': dtColorsWhite,'--o-1-Z29l7Yn': isBefore ? 0 : 1,'--tx-2-Z29l7Yn': isBefore ? "-32px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={isMedia.desktop}>
<div
  data-testid="SignIn.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-3-Z29l7Yn': dtColorsWhite,'--pt-4-Z29l7Yn': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pr-5-Z29l7Yn': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pb-6-Z29l7Yn': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pl-7-Z29l7Yn': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="SignIn.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
/>
<Tysiav2BrandLogo
  viewPath={`${viewPath}/Tysiav2BrandLogo`}
 marginBottom={dtSpaceM}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="The extensible, cloud-based orthodontic software with advanced scheduling, communication tools, automations, and seamless integrations"
 color={dtColorsWhite}
 fontSize={22}
 lineHeight="32px"
/>
</div>
</fromFlow.When>
<div
  data-testid="SignIn.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="SignIn.Vertical:4"
  data-view-path={viewPath}
 style={{'--w-8-Z29l7Yn': isMedia.mobile ? "340px" : "400px"}}
 className={`views-block ${styles.Vertical4}`}
>
<div
  data-testid="SignIn.Vertical:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical5}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 fontWeight={400}
 text="Sign in to greyfinch"
/>
</div>
<fromFlow.When is={flowValue === 'Credentials'}>
<Credentials
  viewPath={`${viewPath}/Credentials`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TwoFactorAuth'}>
<TwoFactorAuth
  viewPath={`${viewPath}/TwoFactorAuth`}
/>
</fromFlow.When>
</div>
</div>
</div>
{children}
</React.Fragment>)
}